// extracted by mini-css-extract-plugin
export default {"button":"AddGame_button__IDGMU","template":"AddGame_template__WGXjG"};